module.exports = __webpack_public_path__ + "static/soo-kids-5ef05063e399f9d734e272f92ab67231.jpg";